module.exports = __webpack_public_path__ + "img/forecast_curves.c0aba898.png";